import { useNotificationStream, type StreamNotification } from "@/common/api/notification/use-notification-stream";
import { useAppFeatureFlag } from "@/common/hooks/use-app-feature-flag";
import { FeatureFlag } from "@/config/feature-flags";
import { userStore } from "@/store/user-store";
import { useCallback, type ReactElement } from "react";
import { toast } from "sonner";
import { WebPushPermissionPromptDialog } from "./components/web-push-permission-prompt-dialog";
import { useWebPushSubscription } from "./use-web-push-subscription/use-web-push-subscription";

export function NotificationsRuntime(): ReactElement | null {
  const user = userStore((state) => state.user);
  const { value: notificationsAreEnabled } = useAppFeatureFlag(FeatureFlag.Notification);
  const enabled = Boolean(notificationsAreEnabled && user);
  const { status, requestPermission } = useWebPushSubscription({ enabled });

  const handleNotification = useCallback((notification: StreamNotification) => {
    toast(notification.title, { description: notification.body });
  }, []);

  useNotificationStream({ enabled, onNotification: handleNotification });

  if (!enabled || status !== "default") {
    return null;
  }

  return <WebPushPermissionPromptDialog requestPermission={requestPermission} />;
}
